var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.6996 0 0 4.6996 0 10.5C0 16.3004 4.6996 21 10.5 21C16.3004 21 21 16.3004 21 10.5C21 4.6996 16.3004 0 10.5 0ZM4.91129 12.1935C4.63186 12.1935 4.40323 11.9649 4.40323 11.6855V9.31452C4.40323 9.03508 4.63186 8.80645 4.91129 8.80645H16.0887C16.3681 8.80645 16.5968 9.03508 16.5968 9.31452V11.6855C16.5968 11.9649 16.3681 12.1935 16.0887 12.1935H4.91129Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecline);
export default __webpack_public_path__ + "static/media/decline.8eefcf2eb99376b7b76af6e464dcb584.svg";
export { ForwardRef as ReactComponent };